import { useFormContext } from 'react-hook-form';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryDemographicsFormValues, IHistoryDemographicsModel } from '@/types/history/history-demographics';
import FieldError from '@components/field-error';

interface IEthnicitySectionProps {
    model: IHistoryDemographicsModel;
    t: TLocalize;
}

const EthnicitySection = ({ model, t }: IEthnicitySectionProps) => {
    const {
        register,
        formState: { errors },
    } = useFormContext<IHistoryDemographicsFormValues>();

    return (
        <>
            <div className='section-heading' style={{ paddingTop: 0 }}>Personal</div>

            <div className="form-group">
                <label className="control-label col-xs-12">
                    {t('DashLabel_RaceEthnicity', 'Race/Ethnicity')}:
                    <FieldError message={errors.ethnicity?.message} />
                </label>
                <div className="col-xs-12 col-md-8">
                    <select className="form-control" {...register('ethnicity')}>
                        <option value="">{t('DashLabel_PleaseSelect', 'Please Select')}</option>
                        {model.ethnicityOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </>
    );
};

export default EthnicitySection;
